// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { memo, useState } from 'react'
import { Tooltip } from 'ui_kit_qmd'
import DOMPurify from 'dompurify'
import { sanitizeNoteHtml, DOMPURIFY_CONFIG } from '../../utils/noteHtmlSanitizer'
import './visitRemarksCardItem.scss'
import editDots from '../../images/charts/editDots.png'
import { EditAlertPopup } from '../../pages/patient-chart-page/components/edit-alert-pop-up/EditAlertPopup'
import { parseUserDateTime } from '../../utils/common'

const VisitRemarksCardItem = memo(
  ({
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    dateTime,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    message,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    author,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    role,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    index,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    isEditAllowed,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    isFormOpened,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    setEditRemarkId,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    setDeleteRemarkId,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    userTimeZoneAbbr,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    userTimeZone,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    isEdited,
  }) => {
    const [isPopUpOpened, setIsPopUpOpened] = useState(false)
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    const togglePopUpVisibility = (e) => {
      e.stopPropagation()
      setIsPopUpOpened((prev) => !prev)
    }

    return (
      <section className='visit-remarks-card-item-container'>
        <div className='visit-remarks-card-item-author-container'>
          <Tooltip content={author} targetId={`visit-remarks-card-${index}`}>
            <div id={`visit-remarks-card-${index}`} className='visit-remarks-card-item-author bold'>
              {author}
            </div>
          </Tooltip>
          {role ?
            <div className='visit-remarks-card-item-author-role bold'> ({role})</div>
          : null}
          {isEditAllowed && !isFormOpened ?
            <div className='visit-remarks-edit-tool-pop-up-container'>
              <img
                role='presentation'
                onClick={togglePopUpVisibility}
                className='remarks-card-tools'
                id={`dots${index}`}
                src={editDots}
                alt='editDots'
              />
              {isPopUpOpened ?
                <EditAlertPopup
                  // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
                  alertId={index}
                  editContainerId='Visit remarks-chart-section'
                  setIsPopUpOpened={setIsPopUpOpened}
                  setDeleteAlertId={setDeleteRemarkId}
                  setEditAlertId={setEditRemarkId}
                />
              : null}
            </div>
          : null}
        </div>
        <span className='visit-remarks-card-item-date-of-creation'>
          {`${parseUserDateTime(dateTime, userTimeZone, true)} ${userTimeZoneAbbr}`}
          {isEdited ?
            <span> (Edited)</span>
          : null}
        </span>
        <div
          className='visit-remarks-card-item-message'
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(sanitizeNoteHtml(message), DOMPURIFY_CONFIG) }}
        />
      </section>
    )
  },
)

export default VisitRemarksCardItem
